import React, { useState } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import PropTypes from 'prop-types';

function DropdownMenuButton({ title = 'Dropdown', items = [], direction, ...args }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <div className="d-flex">
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={direction}>
        <DropdownToggle caret>{title}</DropdownToggle>
        <DropdownMenu {...args}
        style={{ overflow: 'hidden', ...args.style }}>
          {items.map((item, index) => {
            if (item.type === 'divider') {
              return <DropdownItem key={index} divider />;
            }
            if (item.type === 'header') {
              return <DropdownItem key={index} header>{item.label}</DropdownItem>;
            }
            if (item.type === 'text') {
              return <DropdownItem key={index} text>{item.label}</DropdownItem>;
            }
            
            return (
              <DropdownItem
                key={index}
                disabled={item.disabled}
                onClick={item.onClick}
              >
                {item.label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

DropdownMenuButton.propTypes = {
  title: PropTypes.string,
  direction: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func, 
      type: PropTypes.oneOf(['divider', 'header', 'text']), 
      disabled: PropTypes.bool,
    })
  ),
};

export default DropdownMenuButton;